import BaseService from "./BaseService";

export default class ClientService extends BaseService {
  loadedfile;

  constructor(keycloakToken, currentScope) {
    super(keycloakToken, currentScope);
  }

  getStatus() {
    var tab = [
      { id: "Active", label: "Actif" },
      { id: "Migrating", label: "En migration" },
      { id: "DoubleRun", label: "Double Run" },
      { id: "Inactive", label: "Inactif" },
    ];

    return tab;
  }

  getRGPD() {
    var tab = [
      { id: "true", label: "Oui" },
      { id: "false", label: "Non" },
    ];

    return tab;
  }

  async getClients() {
    return this.get(this.GetUri() + "Clients");
  }

  async getParameters() {
    return this.get(this.GetUri() + "Clients/parameters/");
  }

  async create(formData) {
    return await this.postAsync(this.GetUri() + "Clients/add", formData);
  }

  async update(formData) {
    return await this.postAsync(this.GetUri() + "Clients/update", formData);
  }

  async createFromList(dataList) {
    return await this.postAsync(this.GetUri() + "Clients/AddFile", dataList);
  }

  getClientByExternalId(clients, externalId) {
    var result = Object.keys(clients)
      .map((key) => clients[key])
      .filter((client) => client.externalId === externalId);

    if (result.length > 0) {
      return result[0];
    }

    return;
  }

  getService(services, externalId) {
    var result = Object.keys(services)
      .map((key) => services[key])
      .filter((service) => service.externalId === externalId);

    if (result.length > 0) {
      return result[0];
    }

    return;
  }

  async resetClientData(clientExternalId) {
    return this.get(this.GetUri() + `Clients/reset/${clientExternalId}`)
  }

  async resetAllClients() {
    return this.get(this.GetUri() + `Clients/reset`)
  }

  async getHierarchyByClient(client) {
    return this.get(this.GetUri() + `Scope/GetHierarchy/ALL.${client}`)
  }

  async retryJoinAndAck(client, file_id) {
    return this.get(this.GetUri() + `RetryProcessing/joinparts/${client}/${file_id}`)
  }

  //************************************************************************************************************ */
}
